import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { polyfill as promisePolyfill } from 'es6-promise';
import axios from 'axios';
promisePolyfill();
export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["INFO"] = 0] = "INFO";
  LogLevel[LogLevel["WARN"] = 1] = "WARN";
  LogLevel[LogLevel["ERROR"] = 2] = "ERROR";
})(LogLevel || (LogLevel = {}));

export var ClientLogger = function () {
  function ClientLogger(config) {
    _classCallCheck(this, ClientLogger);

    this.config = config;

    if (config.isProduction && !config.logApiEndpoint) {
      throw new Error('Missing logApiEndpoint in production mode!');
    }
  }

  _createClass(ClientLogger, [{
    key: "sendLogRequest",
    value: function sendLogRequest(data) {
      var _this = this;

      return Promise.resolve().then(function () {
        return axios.post(_this.config.logApiEndpoint, [data], {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json',
          timeout: 20000
        });
      }).then(function (_response) {});
    }
  }, {
    key: "log",
    value: function log(logMessage) {
      if (logMessage == null) {
        return Promise.reject('logMessage is null');
      }

      if (this.config.fillPayloadDefaults) {
        try {
          logMessage = this.config.fillPayloadDefaults(logMessage);
        } catch (e) {
          return Promise.reject(e);
        }
      }

      var preparedLogMessage = this.prepareLogMessage(logMessage);

      if (!this.config.isProduction) {
        if (console) {
          console.log(preparedLogMessage);
        }

        return Promise.resolve(undefined);
      } else {
        return this.sendLogRequest(preparedLogMessage).catch(function (error) {
          return Promise.reject(error);
        });
      }
    }
  }, {
    key: "prepareLogMessage",
    value: function prepareLogMessage(logMessage) {
      var currentDate = logMessage.currentDate || new Date();
      var currentTime = currentDate.getTime();
      return _objectSpread(_objectSpread({}, logMessage.payload), {}, {
        current_time: currentTime,
        created: Math.floor(currentTime / 1000),
        msecs: currentTime % 1000,
        client_datetime: currentDate.toISOString(),
        _object: logMessage.object,
        object: logMessage.object,
        _action: logMessage.action,
        trigger: logMessage.trigger,
        _category: logMessage.category || 'website',
        source: logMessage.source || this.config.defaultSource,
        levelname: LogLevel[logMessage.logLevel || this.config.defaultLogLevel],
        name: logMessage.name || 'debug',
        levelno: logMessage.levelno || 20,
        relativeCreated: logMessage.relativeCreated || 0,
        msg: logMessage.msg || '',
        platform: logMessage.platform || 'website',
        session_id: logMessage.session_id || ''
      }, logMessage.prezi_id ? {
        prezi_id: logMessage.prezi_id
      } : {});
    }
  }]);

  return ClientLogger;
}();